import { assertUnreachable } from '@shared/helpers/function.helpers';
import type { MapRenderRequest } from '@shared/models/design/map-render.model';

/**
 * Whether this geometry format needs a live map screenshot.
 * Used by map capture and the report cover toolbar.
 */
export const sourceTypeNeedsScreenshot = (
  sourceType: MapRenderRequest['sourceType'],
): boolean => {
  switch (sourceType) {
    case 'building-json':
      return false;
    case 'screenshot':
    case 'screenshot+building-json':
      return true;
    default:
      return assertUnreachable(sourceType);
  }
};
